export function AuthView() {
  return (
    <section id={"auth-view"} class={"auth-layout"} hidden>
      <aside class={"auth-brand"} aria-hidden={"true"}>
        <div class={"brand-lockup brand-lockup-hero"}>
          <img class={"brand-symbol"} src={"/assets/kuni-mark.svg"} alt={""} />
          <span class={"brand-wordmark"} aria-label={"kUni"}>
            {"kUn"}
            <span class={"brand-i"}>
              {"ı"}
            </span>
          </span>
        </div>
        <div class={"auth-brand-copy"}>
          <span class={"eyebrow"} data-ui-text={"auth.hero.eyebrow"}></span>
          <h2 class={"ui-preline"} data-ui-text={"auth.hero.title"}></h2>
          <p data-ui-text={"auth.hero.body"}></p>
        </div>
        <div class={"auth-brand-foot"}>
          <span>
            {"kUni"}
          </span>
          <span data-ui-text={"auth.hero.footer"}></span>
        </div>
      </aside>
      <main class={"auth-box"} data-auth-stage={"welcome"} id={"auth-box"}>
        <div class={"auth-mobile-brand brand-lockup"}>
          <img class={"brand-symbol small"} src={"/assets/icon.svg"} alt={""} />
          <span class={"brand-wordmark"} aria-label={"kUni"}>
            {"kUn"}
            <span class={"brand-i"}>
              {"ı"}
            </span>
          </span>
        </div>
        <div class={"auth-invite"} id={"auth-invite"} hidden>
          <div class={"auth-invite-icon"} aria-hidden={"true"}>
            {"↗"}
          </div>
          <div class={"auth-invite-copy"}>
            <small>
              {"Приглашение в учебную группу"}
            </small>
            <strong id={"auth-invite-group"}>
              {"Проверяем ссылку…"}
            </strong>
            <span id={"auth-invite-context"}>
              {"Открываем группу — расписание появится сразу."}
            </span>
          </div>
          <span class={"auth-invite-mode"} id={"auth-invite-mode"}>
            {"…"}
          </span>
        </div>
        <section class={"auth-stage auth-stage-welcome"} data-stage={"welcome"}>
          <div class={"auth-illu auth-illu-welcome"} aria-hidden={"true"}>
            <span class={"auth-illu-orb"}>
              {"✦"}
            </span>
          </div>
          <div class={"auth-heading"}>
            <span class={"eyebrow"} data-ui-text={"auth.heading.eyebrow"}></span>
            <h1 data-ui-text={"auth.heading.title"}></h1>
            <p class={"muted"} data-ui-text={"auth.heading.body"}></p>
          </div>
          <div class={"auth-cta-stack"}>
            <button class={"button primary auth-cta-xl"} id={"auth-go-register"} type={"button"}>
              <span data-ui-text={"auth.register.submit"}></span>
              {" "}
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
            <button class={"button auth-cta-xl auth-cta-secondary"} id={"auth-go-login"} type={"button"}>
              <span data-ui-text={"auth.login.submit"}></span>
            </button>
            <button class={"button telegram-auth"} id={"telegram-login"} type={"button"} hidden>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <path d={"M21.6 3.1 18.5 20c-.2 1.2-.9 1.5-1.8.9l-4.8-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.4-4.9 8.9-8.1c.4-.3-.1-.5-.6-.2l-11 6.9-4.7-1.5c-1-.3-1-1 .2-1.5L20.2 3c.9-.3 1.7.2 1.4.1Z"}></path>
              </svg>
              <span>
                <strong data-ui-text={"auth.telegram.title"}></strong>
                <small data-ui-text={"auth.telegram.subtitle"}></small>
              </span>
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
            <div class={"auth-divider"} id={"telegram-auth-divider"} hidden>
              <span data-ui-text={"auth.or"}></span>
            </div>
            <button class={"button auth-guest auth-cta-xl"} id={"guest-login"} type={"button"}>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <path d={"M3 12s3.3-6 9-6 9 6 9 6-3.3 6-9 6-9-6-9-6Z"}></path>
                <circle cx={"12"} cy={"12"} r={"2.5"}></circle>
              </svg>
              <span>
                <strong data-ui-text={"auth.guest.title"}></strong>
                <small data-ui-text={"auth.guest.subtitle"}></small>
              </span>
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
          </div>
        </section>
        <section class={"auth-stage auth-stage-invite"} data-stage={"invite"} hidden>
          <div class={"auth-heading"}>
            <span class={"eyebrow"}>
              {"Приглашение в группу"}
            </span>
            <h1>
              {"Вы почти в группе"}
            </h1>
            <p class={"muted"} id={"auth-invite-lead"}>
              {"Зарегистрируйтесь, чтобы вступить и получить задания, автомат и материалы. Можно сначала просто посмотреть расписание."}
            </p>
          </div>
          <div class={"auth-cta-stack auth-invite-cta"}>
            <button class={"button primary auth-cta-xl"} id={"invite-go-register"} type={"button"}>
              {"Зарегистрироваться и вступить "}
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
            <button class={"button telegram-auth"} id={"invite-telegram-login"} type={"button"} hidden>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <path d={"M21.6 3.1 18.5 20c-.2 1.2-.9 1.5-1.8.9l-4.8-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.4-4.9 8.9-8.1c.4-.3-.1-.5-.6-.2l-11 6.9-4.7-1.5c-1-.3-1-1 .2-1.5L20.2 3c.9-.3 1.7.2 1.4.1Z"}></path>
              </svg>
              <span>
                <strong data-ui-text={"auth.telegram.title"}></strong>
                <small>
                  {"Войти через Telegram и вступить"}
                </small>
              </span>
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
            <div class={"auth-divider"} id={"invite-telegram-divider"} hidden>
              <span data-ui-text={"auth.or"}></span>
            </div>
            <button class={"button auth-cta-xl auth-cta-secondary"} id={"invite-go-login"} type={"button"}>
              {"Уже есть аккаунт? Войти"}
            </button>
            <p class={"auth-invite-hint"}>
              {"После регистрации или входа приглашение применится автоматически."}
            </p>
            <button class={"button auth-guest auth-cta-xl auth-invite-guest"} id={"invite-guest-enter"} type={"button"}>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <path d={"M3 12s3.3-6 9-6 9 6 9 6-3.3 6-9 6-9-6-9-6Z"}></path>
                <circle cx={"12"} cy={"12"} r={"2.5"}></circle>
              </svg>
              <span>
                <strong>
                  {"Смотреть группу как гость"}
                </strong>
                <small>
                  {"Расписание без регистрации"}
                </small>
              </span>
              <b aria-hidden={"true"}>
                {"→"}
              </b>
            </button>
          </div>
        </section>
        <section class={"auth-stage auth-stage-login"} data-stage={"login"} hidden>
          <button class={"auth-back"} type={"button"} data-auth-back={""}>
            {"← Назад"}
          </button>
          <div class={"auth-heading"}>
            <span class={"eyebrow"} data-ui-text={"auth.login.tab"}></span>
            <h1 id={"auth-login-title"}>
              {"С возвращением"}
            </h1>
            <p class={"muted"} id={"auth-login-lead"}>
              {"Войдите, чтобы открыть группу и задания."}
            </p>
          </div>
          <div class={"auth-switch"} role={"tablist"} aria-label={"Авторизация"}>
            <button class={"auth-tab active"} id={"login-tab"} type={"button"} data-ui-text={"auth.login.tab"}></button>
            <button class={"auth-tab"} id={"register-tab"} type={"button"} data-ui-text={"auth.register.tab"}></button>
          </div>
          <form id={"login-form"} class={"form auth-form"}>
            <label>
              <span data-ui-text={"auth.field.email"}></span>
              <input name={"email"} type={"email"} autoComplete={"email"} placeholder={"student@university.ru"} required />
            </label>
            <label>
              <span data-ui-text={"auth.field.password"}></span>
              <input name={"password"} type={"password"} autoComplete={"current-password"} minLength={"10"} placeholder={"••••••••••"} required />
            </label>
            <button class={"auth-forgot"} id={"forgot-password"} type={"button"} data-ui-text={"auth.forgot"}></button>
            <button class={"button primary auth-submit"} type={"submit"}>
              <span data-ui-text={"auth.login.submit"}></span>
              {" "}
              <span aria-hidden={"true"}>
                {"→"}
              </span>
            </button>
          </form>
        </section>
        <section class={"auth-stage auth-stage-register"} data-stage={"register"} hidden>
          <button class={"auth-back"} type={"button"} data-auth-back={""}>
            {"← Назад"}
          </button>
          <div class={"auth-heading"}>
            <span class={"eyebrow"} data-ui-text={"auth.register.tab"}></span>
            <h1 id={"auth-register-title"}>
              {"Создать аккаунт"}
            </h1>
            <p class={"muted"} id={"auth-register-lead"}>
              {"Минута — и вы внутри. Пароль от 10 символов."}
            </p>
          </div>
          <button class={"button telegram-auth auth-invite-telegram-inline"} id={"register-telegram-login"} type={"button"} hidden>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M21.6 3.1 18.5 20c-.2 1.2-.9 1.5-1.8.9l-4.8-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.4-4.9 8.9-8.1c.4-.3-.1-.5-.6-.2l-11 6.9-4.7-1.5c-1-.3-1-1 .2-1.5L20.2 3c.9-.3 1.7.2 1.4.1Z"}></path>
            </svg>
            <span>
              <strong data-ui-text={"auth.telegram.title"}></strong>
              <small>
                {"Быстрее через Telegram"}
              </small>
            </span>
            <b aria-hidden={"true"}>
              {"→"}
            </b>
          </button>
          <div class={"auth-divider"} id={"register-telegram-divider"} hidden>
            <span data-ui-text={"auth.or"}></span>
          </div>
          <form id={"register-form"} class={"form auth-form"}>
            <label>
              <span data-ui-text={"auth.field.name"}></span>
              <input name={"display_name"} autoComplete={"name"} minLength={"2"} maxLength={"100"} placeholder={"Иван Иванов"} required />
            </label>
            <label>
              <span data-ui-text={"auth.field.email"}></span>
              <input name={"email"} type={"email"} autoComplete={"email"} placeholder={"student@university.ru"} required />
            </label>
            <label class={"auth-password-field"}>
              <span data-ui-text={"auth.field.password"}></span>
              <span class={"auth-password-wrap"}>
                <input id={"register-password"} name={"password"} type={"password"} autoComplete={"new-password"} minLength={"10"} maxLength={"256"} data-ui-text-placeholder={"auth.password.new_placeholder"} required />
                <button class={"auth-password-toggle"} type={"button"} data-password-toggle={"register-password"} aria-label={"Показать пароль"} title={"Показать пароль"} aria-pressed={"false"}>
                  <svg class={"auth-password-icon-show"} viewBox={"0 0 24 24"} aria-hidden={"true"}>
                    <path d={"M3 12s3.3-6 9-6 9 6 9 6-3.3 6-9 6-9-6-9-6Z"}></path>
                    <circle cx={"12"} cy={"12"} r={"2.5"}></circle>
                  </svg>
                  <svg class={"auth-password-icon-hide"} viewBox={"0 0 24 24"} aria-hidden={"true"} hidden>
                    <path d={"M3 12s3.3-6 9-6 9 6 9 6-3.3 6-9 6-9-6-9-6Z"}></path>
                    <circle cx={"12"} cy={"12"} r={"2.5"}></circle>
                    <path d={"M4 4l16 16"}></path>
                  </svg>
                </button>
              </span>
            </label>
            <details class={"auth-advanced"}>
              <summary>
                {"Дополнительно"}
              </summary>
              <label>
                <span data-ui-text={"auth.field.username"}></span>
                {" "}
                <span class={"optional"} data-ui-text={"auth.field.optional"}></span>
                <input name={"username"} autoComplete={"username"} minLength={"3"} maxLength={"32"} placeholder={"ivanov"} />
              </label>
            </details>
            <div class={"legal-registration-consent"}>
              <p data-ui-text={"legal.registration.prefix"}></p>
              <label class={"legal-consent-check"}>
                <input id={"registration-pd-consent"} type={"checkbox"} required />
                <span data-ui-text={"legal.registration.checkbox"}></span>
              </label>
              <div class={"legal-inline-links"}>
                <a href={"/consent"} target={"_blank"} rel={"noopener"} data-ui-text={"legal.registration.read"}></a>
                <span>
                  {"·"}
                </span>
                <a href={"/privacy"} target={"_blank"} rel={"noopener"} data-ui-text={"legal.registration.privacy"}></a>
              </div>
            </div>
            <button class={"button primary auth-submit"} type={"submit"}>
              <span data-ui-text={"auth.register.submit"}></span>
              {" "}
              <span aria-hidden={"true"}>
                {"→"}
              </span>
            </button>
          </form>
        </section>
        <section class={"auth-stage auth-stage-guest"} data-stage={"guest"} hidden>
          <button class={"auth-back"} type={"button"} data-auth-back={""}>
            {"← Назад"}
          </button>
          <div class={"auth-heading"}>
            <span class={"eyebrow"}>
              {"Без регистрации"}
            </span>
            <h1>
              {"Смотреть как гость"}
            </h1>
            <p class={"muted"}>
              {"Расписание группы или преподавателя — без аккаунта."}
            </p>
          </div>
          <div class={"auth-guest-choice"}>
            <button type={"button"} class={"auth-guest-choice-card active"} data-guest-panel={"group"}>
              <strong>
                {"Я студент"}
              </strong>
              <small>
                {"Найти учебную группу"}
              </small>
            </button>
            <button type={"button"} class={"auth-guest-choice-card"} data-guest-panel={"teacher"}>
              <strong>
                {"Я преподаватель"}
              </strong>
              <small>
                {"Найти себя по ФИО"}
              </small>
            </button>
          </div>
          <section class={"auth-group-discovery"} id={"auth-group-discovery"}>
            <div class={"auth-group-discovery-head"}>
              <div>
                <strong>
                  {"Найди свою группу"}
                </strong>
                <span>
                  {"Расписание без регистрации."}
                </span>
              </div>
              <span class={"auth-public-pill"}>
                {"без входа"}
              </span>
            </div>
            <label class={"auth-group-search"} for={"auth-group-search-input"}>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <circle cx={"11"} cy={"11"} r={"6.5"}></circle>
                <path d={"m16 16 4 4"}></path>
              </svg>
              <input id={"auth-group-search-input"} type={"search"} autoComplete={"off"} spellcheck={"false"} placeholder={"Например: БИС-111"} />
            </label>
            <div class={"auth-group-search-results"} id={"auth-group-search-results"} hidden></div>
            <p class={"auth-group-discovery-note"}>
              {"Если названия совпадают, kUni покажет ВУЗ, институт и программу."}
            </p>
            <button class={"button primary auth-submit"} id={"guest-open-catalog"} type={"button"}>
              {"Открыть каталог групп "}
              <span aria-hidden={"true"}>
                {"→"}
              </span>
            </button>
          </section>
          <section class={"auth-group-discovery auth-teacher-discovery"} id={"auth-teacher-discovery"} hidden>
            <div class={"auth-group-discovery-head"}>
              <div>
                <strong>
                  {"Преподаватель"}
                </strong>
                <span>
                  {"Введи ФИО и открой расписание."}
                </span>
              </div>
              <span class={"auth-public-pill"}>
                {"без входа"}
              </span>
            </div>
            <label class={"auth-group-search"} for={"auth-teacher-search-input"}>
              <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
                <circle cx={"11"} cy={"11"} r={"6.5"}></circle>
                <path d={"m16 16 4 4"}></path>
              </svg>
              <input id={"auth-teacher-search-input"} type={"search"} autoComplete={"off"} spellcheck={"false"} placeholder={"Например: Эфендиев Тахир Сейпуевич"} />
            </label>
            <div class={"auth-group-search-results"} id={"auth-teacher-search-results"} hidden></div>
          </section>
          <div class={"auth-guest-block"} id={"auth-guest-block"} hidden></div>
        </section>
        <p class={"auth-error"} id={"auth-error"} hidden></p>
        <p class={"auth-note"} data-ui-text={"auth.note"}></p>
        <div class={"auth-legal-links"}>
          <a href={"/privacy"} data-ui-text={"legal.links.privacy"}></a>
          <a href={"/consent"} data-ui-text={"legal.links.consent"}></a>
        </div>
      </main>
    </section>
  );
}
